



































import { Component, Prop, Mixins, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import GTitleBar from '@/components/GTitleBar.vue';
import { GPageBase } from '@/mixins';
import { EventProgress } from '@/models/jgrow/event-progress';

@Component({
  name: 'GJgrowEventDetailProgressView',
  components: {
    GTitleBar,
    GJgrowEventDetailProgressView,
  },
  computed: {},
  methods: {},
})
export default class GJgrowEventDetailProgressView extends mixins(GPageBase) {
  progressColumns: any[] = [];

  @Prop() progress: EventProgress[];

  created() {

  }
  async mounted() {
    this.progressColumns = [
      {
        title: 'ログインID',
        key: 'studentNumber',
        align: 'center',
      },
      {
        title: `学年`,
        key: 'grade',
        width: 50,
        align: 'center',
      },
      {
        title: `クラス`,
        key: 'schoolClassName',
        width: 80,
        align: 'center',
      },
      {
        title: `生徒名`,
        key: 'studentName',
        align: 'center',
      },
      {
        title: `事前アンケート完了日`,
        slot: 'beforeSurveyCompletedAt',
        align: 'center',
      },
      {
        title: `事後アンケート完了日`,
        slot: 'afterSurveyCompletedAt',
        align: 'center',
      },
      {
        title: `追加設問回答1`,
        key: 'q1Answer',
        align: 'left',
      },
      {
        title: `追加設問回答2`,
        key: 'q2Answer',
        align: 'left',
      },
      {
        title: `追加設問回答3`,
        key: 'q3Answer',
        align: 'left',
      },
    ];
  }

  // 参加者の進捗
  get eventProgress(): EventProgress[] {
    return this.progress;
  }

  // 参加者人数
  get studentsLength(): number {
    return this.progress.length;
  }

  // 事前アンケート完了者数
  get beforeCompletedCount(): number {
    return this.progress.filter((ep: EventProgress) => {
      if (ep.beforeSurveyCompleted) return ep;
    }).length;
  }

  // 事前アンケート完了者数 割合（パーセント）
  get beforeCompletedPer(): number {
    return Math.ceil((this.beforeCompletedCount / this.studentsLength) * 100);
  }

  // 事前アンケート完了者数
  get afterCompletedCount(): number {
    return this.progress.filter((ep: EventProgress) => {
      if (ep.afterSurveyCompleted) return ep;
    }).length;
  }

  // 事後アンケート完了者数 割合（パーセント）
  get afterCompletedPer(): number {
    return Math.ceil((this.afterCompletedCount / this.studentsLength) * 100);
  }
}
